import React from "react";

const CommentActionButtons = ({
  comment,
  currentUserProfileId,
  onDelete,
  onReport, 
}) => {
  const isOwner = currentUserProfileId === comment.author?._id;

  return (
    <div className="flex gap-2 mt-2 animate-fade-in" style={{ pointerEvents: "auto" }}>
      {isOwner ? (
        <button
          onClick={(e) => {
            onDelete(comment._id);
          }}
          type="button"
          style={{ pointerEvents: "auto", cursor: "pointer" }}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 border border-red-300 rounded-md text-sm font-medium text-red-600 hover:bg-red-100 transition-colors"
        >
          Delete
        </button>
      ) : (
        <button
          onClick={(e) => {
            onReport(comment._id);
          }}
          type="button"
          style={{ pointerEvents: "auto", cursor: "pointer" }}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 border border-red-300 rounded-md text-sm font-medium text-red-600 hover:bg-red-100 transition-colors"
        >
          Report
        </button>
      )}
    </div>
  );
};

export default CommentActionButtons;